import type { NodeDetail } from '@/types'
import guardianStyles from './GuardianAlphaStatusPanel.module.css'
import styles from './nodeDetail.module.css'
import { useGuardianAlphaRestart } from './useGuardianAlphaRestart'

interface Props {
  node: NodeDetail
  disabledReason?: string
}

export function GuardianAlphaRestartButton({ node, disabledReason }: Props) {
  const {
    service,
    restarting,
    error,
    restartDisabledReason,
    restart,
  } = useGuardianAlphaRestart(node)
  const restartInProgress = service?.last_restart_status === 'running' || restarting
  const effectiveDisabledReason = disabledReason ?? restartDisabledReason

  return (
    <div className={guardianStyles.restartAction}>
      {error && <span className={guardianStyles.restartActionError} role="alert">{error}</span>}
      <button
        type="button"
        className={styles.primaryButton}
        onClick={restart}
        disabled={Boolean(effectiveDisabledReason)}
        title={effectiveDisabledReason ?? undefined}
      >
        {restartInProgress ? 'Restarting...' : 'Restart GuardianAlpha'}
      </button>
    </div>
  )
}
